<template>
  <div id="limit" class="container">
    <div class="t" v-bind:style="{backgroundImage:'url('+ serve  + banner + ')'}"></div>

    <div class="clear" style="background-color:#fff;margin-bottom:20px">
      <div class="clear-item i1" :class="{liTab1 : tab ==  1 }" @click="tab_bind(1)">
        <div class="il_div1">08:00—12:00</div>
        <div>试剂专场</div>
      </div>
      <!-- v-if="currentRound<=22" -->
      <div class="clear-item i1" :class="{liTab2 : tab ==  2 }" @click="tab_bind(2)">
        <div class="il_div1">12:00—18:00</div>
        <div>耗材专场</div>
      </div>
      <div class="clear-item i1" :class="{liTab3 : tab ==  3 }" @click="tab_bind(3)">
        <div class="il_div1">18:00—23:00</div>
        <div>综合专场</div>
      </div>
    </div>
    <div class="countdown lv2Text" v-show="istab1">
      <i class="fas fa-stopwatch fa-2x"></i>
      <span style="margin-right:5px">距离本场结束还有</span>
      <span class="count">{{_.padStart(hours, 2,'0')}}</span>：
      <span class="count">{{_.padStart(minutes, 2,'0')}}</span>：
      <span class="count">{{_.padStart(seconds, 2,'0')}}</span>
    </div>
    <div class="countdown lv2Text" v-show="istab">
      <i class="fas fa-stopwatch fa-2x"></i>
      <span style="margin-right:5px">敬请期待</span>
    </div>
    <div class="shopping clearfix">
      <div class="gkl_topic" v-for="(item,index) of data" :key="index">
        <router-link v-if="istab1" :to="'/product2/'+item.r_id" class="topic_img">
          <img style="width:192px;height:190px" :src="serve +item.images" alt />
        </router-link>
        <!--  -->
        <div v-else class="topic_img">
          <img style="width:192px;height:190px" :src="serve +item.images" alt />
        </div>
        <!--  -->
        <router-link
          v-if="istab1"
          :to="'/product2/'+item.r_id"
          tag="div"
          class="topic_title"
        >{{item.title}}</router-link>
        <div class="topic_title" v-else>{{item.title}}</div>

        <div class="topic_money">&yen;{{item.rush_price}}</div>
        <div class="topic_num">
          
          <div v-if="istab1">
            <el-progress
              :text-inside="true"
              :stroke-width="18"
              :percentage="item.percent"
              color="#e84d49"
            ></el-progress>
          </div>

          <span  v-if="istab1" style="font-size:14px;color:rgba(102,102,102,1);line-height:26px">剩余{{item.number}}</span>
          <div v-else class="topic_num_btn">即将开始</div>
        </div>
      </div>
    </div>
    <div class="foot_loading" v-show="foot_loading">
      <i class="el-icon-loading" style="font-size:50px"></i>
      <span>加载中</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      data: [],
      h: 0,
      m: 0,
      s: 0,
      currentRound: 0,
      banner: "",
      hours: 0,
      minutes: 0,
      seconds: 0,
      second: 0,
      count_down: "",
      tab: null,
      istab: false,
      istab1: true,
      count_page: 1,
      scrollTop: 0,
      foot_loading: false,
      tabLength: null,
      flag: true
    };
  },
  watch: {
    scrollTop: function(news, old) {
      if (news > old) {
        if (news / 600 > this.count_page) {
          this.count_page++;
          this.initData1(this.tab);
        }
      } else {
      }
    }
  },
  activated(){
    this.$store.commit('set_top_nav' , '2')

  },
  created() {
    // this.$store.state.top_nav = '2'

    var that = this;
    window.onscroll = function() {
      that.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    };
    //
    this.axios
      .get(this.serve + "/get_banner?type=rush")
      .then(res => {
        this.banner = res.data.data.image;
      });
    var that = this;
    var h = that.dayjs().hour();
    if (h >= 8 && h < 12) {
      that.tab = 1;
    } else if (h >= 12 && h < 18) {
      that.tab = 2;
    } else if (h >= 18 && h < 23) {
      that.tab = 3;
    }
    // var  t1 = setInterval(function() {
    //   if (that.second == 0) {
    //     clearInterval(t1)
    //   }
    //   that.second--;
    //   var surplus = that.second;
    //   that.hours = Math.floor(surplus / 3600);
    //   that.minutes = Math.floor((surplus % 3600) / 60);
    //   that.seconds = surplus % 60;

    //   // var h2 = h % 2 == 0 ? h + 2 : h + 1;
    //   // console.log(h)

    //   // console.log(h2)

    //   // that.currentRound = h2 - 2;
    //   // var date1 = that.dayjs();
    //   // var date2 = that.dayjs(
    //   //   that.dayjs().format("YYYY-MM-DD" + " " + h2 + ":00:00")
    //   // );
    //   // that.distance = date2.diff(date1);
    //   // that.hours = Math.floor(
    //   //   (that.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    //   // );
    //   // that.minutes = Math.floor(
    //   //   (that.distance % (1000 * 60 * 60)) / (1000 * 60)
    //   // );
    //   // that.seconds = Math.floor((that.distance % (1000 * 60)) / 1000);
    // }, 1000);
    this.$store.state.user_location = "限时抢购";
    this.$store.state.leftMenuIndex = 15;
    this.initData();
  },
  mounted() {},
  // mounted() {},
  // watch: {
  //   "second": function(val, old) {
  //     console.log(val);

  //   }
  // },
  methods: {
    tab_bind(v) {
      // console.log(v);
      this.tab = v;
      this.initData(v);
    },
    initData(v) {
      // console.log(this.count_page)
      this.axios
        .get(this.serve + "/rush_product", {
          params: {
            time: v
            // page : this.count_page
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          // for(var  key in res.data.data.results){
          //   this.data.push(res.data.data.results[key])
          // }
          this.second = res.data.data.second;
          // this.foot_loading = false;
          // var h = res.data.data.H;
          // console.log(this.flag)
          if (this.flag) {
            var that = this;
            that.flag = false;
            var t1 = setInterval(function(e) {
              if (that.second <= 0) {
                clearInterval(t1);
                that.istab = true;
                that.istab1 = false;
              } else {
                that.istab = false;
                that.istab1 = true;
              }
              that.second--;
              var surplus = that.second;
              that.hours = Math.floor(surplus / 3600);
              that.minutes = Math.floor((surplus % 3600) / 60);
              that.seconds = surplus % 60;
              // var h2 = h % 2 == 0 ? h + 2 : h + 1;
              // console.log(h)

              // console.log(h2)

              // that.currentRound = h2 - 2;
              // var date1 = that.dayjs();
              // var date2 = that.dayjs(
              //   that.dayjs().format("YYYY-MM-DD" + " " + h2 + ":00:00")
              // );
              // that.distance = date2.diff(date1);
              // that.hours = Math.floor(
              //   (that.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              // );
              // that.minutes = Math.floor(
              //   (that.distance % (1000 * 60 * 60)) / (1000 * 60)
              // );
              // that.seconds = Math.floor((that.distance % (1000 * 60)) / 1000);
            }, 1000);
            that.flag = true;
          }

          for (var item of this.data) {
            let total =
              _.toInteger(item.sell_number) + _.toInteger(item.number);
            let percent = (_.toInteger(item.number) / total) * 100;
            let percent2 = _.floor(percent);
            item.percent = percent2;
          }
        });
    },
    initData1(v) {
      this.foot_loading = true;
      this.axios
        .get(this.serve + "/rush_product", {
          params: {
            time: v,
            page: this.count_page
          }
        })
        .then(res => {
          this.foot_loading = false;
          // alert(res.data.data.results.length)
          this.tabLength = res.data.data.results.length;
          // this.data = res.data.data.results
          for (var key in res.data.data.results) {
            this.data.push(res.data.data.results[key]);
          }
          this.second = res.data.data.second;
          for (var item of this.data) {
            let total =
              _.toInteger(item.sell_number) + _.toInteger(item.number);
            let percent = (_.toInteger(item.number) / total) * 100;
            let percent2 = _.floor(percent);
            item.percent = percent2;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#limit {
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .foot_loading {
    width: 150px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .gkl_topic {
    padding-left: 4px;
    margin-right: 4px;
    margin-bottom: 20px;
    width: 232px;
    height: 338px;
    background: #fff;
    float: left;
    cursor: pointer;
    .topic_img {
      margin: 0 auto;
      img {
        display: block;
        margin: 0 auto;
      }
    }
    .topic_title {
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      height: 39px;
      overflow: hidden;
      line-height: 20px;
      padding-left: 25px;
      padding-right: 25px;
      text-align: center;
      padding-top: 10px;
    }
    .topic_money {
      font-size: 18px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(246, 78, 98, 1);
      text-align: center;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    .topic_num {
      // background: orange;
      padding-left: 25px;
      padding-right: 25px;
      // display: flex;
      // justify-content: space-around;
      .topic_num_btn {
        width: 98px;
        height: 34px;
        background: rgba(51, 51, 51, 1);
        margin: 0 auto;
        color: #fff;
        line-height: 34px;
        text-align: center;
      }
      > span {
        width: 10px;
      }
    }
  }
  .count {
    background-color: #e2211c;
    color: #fff;
    border-radius: 5px;
    padding: 5px 2px;
  }
  .fa-stopwatch {
    position: relative;
    top: 8px;
    margin-right: 10px;
  }
  .countdown {
    font-size: 20px;
    text-align: center;
    padding: 15px 0 25px 0;
    background-color: #fff;
    margin-bottom: 10px;
  }
  padding-bottom: 30px;
  .i1 {
    width: 33.333%;
    text-align: center;
    line-height: 20px;
    padding: 10px 0;
    cursor: pointer;
    color: #e2211c;
  }
  .il_div1 {
    font-size: 22px;
    font-family: "MicrosoftYaHei";
    font-weight: bold;
    line-height: 30px;
  }
  .liTab1 {
    background: rgba(239, 39, 103, 1);
    color: #ffffff;
  }
  .liTab2 {
    background: rgba(226, 33, 28, 1);
    color: #ffffff;
  }
  .liTab3 {
    background: #c72e08;
    color: #ffffff;
  }
  .i3 {
    width: 33.333%;
    text-align: center;
    line-height: 20px;
    padding: 10px 0;
    color: #fff;
    cursor: pointer;
  }
  .i2 {
    cursor: pointer;
    // background-color: #e2211c;
    width: 33.333%;
    text-align: center;
    line-height: 20px;
    padding: 10px 0;
    color: #e2211c;
  }
  .item {
    background-color: #fff;
    margin: 10px 0;
  }
  .img {
    width: 150px;
    height: 150px;
    margin: 10px auto;
  }
  .t1 {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .t {
    height: 270px;
  }
}
</style>